module.exports = __webpack_public_path__ + "img/u36.87e130d0.png";